WiseMetering.Collection.Buckets = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Bucket,
    url: '/buckets'
});
